import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "../../assets/images/icons/logo-ikiai.png";
import {
  LEGAL_LANGUAGE_LABELS,
  getLegalAppName,
  getPolicyLanguages,
} from "../../constant/legalApps";
import "./LegalLayout.css";

function LegalLayout({ app, lang, policyType, slug, children }) {
  const history = useHistory();
  const appName = getLegalAppName(app, lang);
  const languages = getPolicyLanguages(app, policyType);
  const selectedLanguage = languages.includes(lang) ? lang : "";

  useEffect(() => {
    document.documentElement.classList.add("legal-page");
    document.body.classList.add("legal-page");

    return () => {
      document.documentElement.classList.remove("legal-page");
      document.body.classList.remove("legal-page");
    };
  }, []);

  const handleLanguageChange = (event) => {
    history.push(`/${event.target.value}/${policyType}/${slug}`);
  };

  return (
    <div className="legal-layout">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-brand" aria-label="IKI AI home">
            <img src={logo} alt="IKI AI" />
          </Link>

          {appName && <span className="legal-app-name">{appName}</span>}

          {languages.length > 1 && (
            <label className="legal-language-picker">
              <span className="sr-only">Language</span>
              <select value={selectedLanguage} onChange={handleLanguageChange}>
                {!selectedLanguage && (
                  <option value="" disabled>
                    Language
                  </option>
                )}
                {languages.map((language) => (
                  <option key={language} value={language}>
                    {LEGAL_LANGUAGE_LABELS[language] || language.toUpperCase()}
                  </option>
                ))}
              </select>
            </label>
          )}
        </div>
      </header>

      <main className="legal-main">{children}</main>

      <footer className="legal-footer">
        © {new Date().getFullYear()} IKI AI
      </footer>
    </div>
  );
}

export default LegalLayout;
